import BrowserSupport from './assets/browser-support.js';
BrowserSupport.isIE10();

import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2';
import VTooltip from 'v-tooltip';
import './styles/app.scss';

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(VTooltip);
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'main',
    },
  ],
});

new Vue({
  el: '#vue-app',
  router,
  render (h) {
    return h(App, {});
  },
});

Vue.mixin({
  methods: {
    philaLink( string ) {
      return string.replace(/http?:\/\/admin.phila.gov/g, '')
        .replace(/https?:\/\/admin.phila.gov/g, '')
        .replace(/http?:\/\/staging-admin.phila.gov/g, '')
        .replace(/https?:\/\/staging-admin.phila.gov/g, '')
        .replace(/https?:\/\/test-admin.phila.gov/g, '')
        .replace(/http?:\/\/test-admin.phila.gov/g, '');
    },
  },
});